export const EXTERNAL_FILE_BATCH_LINK_MAX = 50;

type SelectedExternalBase = {
  connectionUuid: string;
  externalId: string;
  name: string;
  driveId?: string;
};

export type SelectedExternalFile = SelectedExternalBase & {
  kind: "file";
  mimeType: string;
};

type SelectedExternalFolder = SelectedExternalBase & {
  kind: "folder";
};

export type SelectedExternalItem =
  | SelectedExternalFile
  | SelectedExternalFolder;
